import { DocumentTextIcon } from '@heroicons/react/24/outline';
import React from 'react';

const ExpenseFileLocation = ({ expFile, className }) => {
   const appRoot = process.env.REACT_APP_ROOT_URL;

  if(expFile){
     var expFileUrl = `${appRoot}expense_file/${expFile}`;
     return <a href={`${expFileUrl}`} target='_blank'><DocumentTextIcon className='h-5'/></a>
  } else {
     return "Missing file!"
  }

  // Correctly pass className to the img element
  // return <span className={className} src={expFileUrl} alt="User Avatar" /></span>;
   
};

export default ExpenseFileLocation;
